<template>


	<div style="display: flex;">

		<img v-for="(i,index) in startList" :key="index" @click="isCanClick?clickStars(index):''" :src="startTotal1>index?star1:star2" style="width: 20px;height: 20px;" :style="{'cursor': isCanClick?'pointer':''}"/>

	</div>
	

</template>

<script>
	import start1 from '@/assets/start1.png'
	import start2 from '@/assets/start2.png'
	export default {
		name: 'start',
		props: {
			//是否可以点击星星进行打分
			isCanClick: {
				type: Boolean,
				default: false
			},
			startTotal: {//评分总数，（选中的星星总个数）
				type: Number,
				default: 0
			},
		},
	
		data() {
			return {
				star1: start1, //亮星星
				star2: start2, //暗星星
				startTotal1:this.startTotal,
				startList: [0, 1, 2, 3, 4],


			}
		},
		methods: {
			getStartTotal(){
				return this.startTotal1;
			},
			setStartTotal(v){
				this.startTotal1=v;
			},
			//点击星星
			clickStars(i) {
				if(i+1==this.startTotal1){//当前点击的是已选中的
					console.log(111)
					this.startTotal1 -= 1;
					console.log('this.startTotal1',this.startTotal1)
					return
				}
				this.startTotal1 = i + 1
				console.log('this.startTotal1',this.startTotal1)
				this.$emit('clickStart',this.startTotal1)
				this.$emit('click')
			}
		},
	}
</script>

<style scoped>

</style>
